import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TabsHeader = styled('div')({
    marginTop: 0,
});

export const TabBodyHeader = styled('div')({
    marginTop: 10,
});

export const TabBodyDescription = styled('div')({
    margin: '16px 0px',
});

export const EmailField = styled('div')({
    maxWidth: 688,
    marginTop: 32,
});

export const EmailFieldHelpText = styled('div')({
    marginTop: 5,
    marginBottom: 50,
});

export const UserInfoBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    maxWidth: 688,
    border: `1px solid ${theme.legacy.colors.neutralPlatinum}`,
    boxSizing: 'border-box',
    borderRadius: 8,
    height: 80,
    marginTop: 32,
    marginBottom: 8,
}));

export const UserAvatarWrapper = styled('div')({
    width: 48,
    margin: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const UserAvatar = styled('div')({
    width: 48,
    height: 48,
});

export const UserNameContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 'auto',
});

export const FullName = styled('div')({
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
});

export const Title = styled('div')(({ theme }) => ({
    lineHeight: '14px',
    color: theme.legacy.colors.neutralGrey,
}));
